export const selectAuthLoading = (state) => state?.auth?.loading;
export const selectAuthToken = (state) => state?.auth?.token;
export const selectMasjidUuid = (state) => state?.auth?.masjidUuid;
export const selectUserDetails = (state) => state?.auth?.userData;
